<axis-modal
  [show]="showInfo"
  (closed)="showInfo = false"
  [closeOnBackdrop]="true"
  style="--modal-width: 520px"
  >
  <div modal-header class="info-modal__header">
    <h2 class="info-modal__title">About {{ restaurantName }}</h2>

    <button
      type="button"
      class="info-modal__close"
      aria-label="Close information modal"
      (click)="showInfo = false"
      >
      <i class="fa-solid fa-xmark"></i>
    </button>
  </div>

  <div class="info-modal__body">
    @if (restaurantAddress) {
      <section class="info-section">
        <h3 class="info-section__title">Address</h3>
        <div class="info-section__card">
          <p class="address-copy">{{ restaurantAddress }}</p>
        </div>
      </section>
    }

    <section class="info-section">
      <h3 class="info-section__title">Allergens</h3>
      <div class="info-section__card">
        <p>
          Please call <strong>{{ restaurantName }}</strong> to find out more
          information about their allergen information.
        </p>

        @if (restaurantPhone) {
          <p class="contact-line">
            <span>Phone:</span>
            <a [href]="'tel:' + restaurantPhone">{{ restaurantPhone }}</a>
          </p>
        }
        @if (allergensNote) {
          <p class="muted">{{ allergensNote }}</p>
        }
      </div>
    </section>

    <section class="info-section">
      <h3 class="info-section__title">Restaurant Opening Hours</h3>
      <div class="info-section__card">
        <ul class="hours-list">
          @for (d of openingHours; track d) {
            <li>
              <span class="day">{{ d.day }}</span>
              @if (!d.isClosed) {
                <span class="times">
                  @if (d.intervals?.length) {
                    @for (i of d.intervals; track i; let last = $last) {
                      <span>
                        {{ formatTime(i.open) }} – {{ formatTime(i.close) }}
                        @if (!last) {
                          <span>, </span>
                        }
                      </span>
                    }
                  } @else {
                    {{ formatTime(d.open) }} – {{ formatTime(d.close) }}
                  }
                </span>
              } @else {
                <span class="closed">Closed</span>
              }
            </li>
          }
        </ul>
      </div>
    </section>

    <section class="info-section">
      <h3 class="info-section__title">Delivery Hours</h3>
      <div class="info-section__card">
        <ul class="hours-list">
          @for (d of deliveryHours; track d) {
            <li>
              <span class="day">{{ d.day }}</span>
              @if (!d.isClosed) {
                <span class="times">
                  @if (d.intervals?.length) {
                    @for (i of d.intervals; track i; let last = $last) {
                      <span>
                        {{ formatTime(i.open) }} – {{ formatTime(i.close) }}
                        @if (!last) {
                          <span>, </span>
                        }
                      </span>
                    }
                  } @else {
                    {{ formatTime(d.open) }} – {{ formatTime(d.close) }}
                  }
                </span>
              } @else {
                <span class="closed">Closed</span>
              }
            </li>
          }
        </ul>
      </div>
    </section>

    <section class="info-section">
      <h3 class="info-section__title">Fees</h3>
      <div class="info-section__card fees">
        <div class="fees__row">
          <span>Minimum Order</span>
          <strong>{{ fees?.minOrder | currency: "GBP" }}</strong>
        </div>

        <div class="fees__row">
          <span>Delivery Fee</span>
          <strong>
            @if (fees?.deliveryFee === 0) {
              Free
            }
            @if (fees?.deliveryFee! > 0) {
              {{ fees?.deliveryFee | currency: "GBP" }}
            }
          </strong>
        </div>

        @if (fees?.serviceFee != null) {
          <div class="fees__row">
            <span>Service Fee</span>
            <strong>{{ fees?.serviceFee | currency: "GBP" }}</strong>
          </div>
        }
      </div>
    </section>
  </div>

  <div modal-footer class="info-modal__footer">
    <button class="btn-primary" (click)="showInfo = false">Close</button>
  </div>
</axis-modal>
